import React from "react";
import { useEffect, useState } from "react";
import { whoami, getClasses } from "../services/APIClient";
import { Container, Row, Col } from "react-bootstrap";
import CreateClassForm from "../components/CreateClassForm";
import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import OrientationPrompt from "../components/OrientationPrompt";
import "../components/CreateClass.css";
import { useLocation } from "react-router";

function CreateClass(props) {
  let location = useLocation();

  let name = location.state.name.name;
  let schoolid = location.state.schoolid.schoolid;
  let teacherid = location.state.teacherid.teacherid;
  let classes = location.state.classes.classes;
  let rollNumber = location.state.rollNumber;
  let teacherRoles = location.state.teacherRoles.teacherRoles;
  let teachers = location.state.teachers.teachers;
  const handoverSelection = location.state.handoverSelection || null;

  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  return (
    <Container fluid className="vh-100">
      <HeadingBanner
        name={"Create a New Class! "}
        isLoggedIn={true}
        cloud={true}
        teacherid={teacherid}
      />
      <Row className="h-100">
        <LeftPanel />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background">
          <CreateClassForm
            teacherid={teacherid}
            rollNumber={rollNumber}
            teacherRoles={teacherRoles}
            handoverSelection={handoverSelection}
          />
        </Col>
      </Row>
      {isPortrait && <OrientationPrompt />}
    </Container>
  );
}

export default CreateClass;


// import React from "react";
// import { useEffect, useState } from "react";
// import { whoami, getClasses, getClassConversionMethods} from "../services/APIClient";
// import { Container, Row, Col, Modal, Button } from "react-bootstrap";
// import CreateClassForm from "../components/CreateClassForm";
// import HeadingBanner from "../components/HeadingBanner";
// import LeftPanel from "../components/LeftPanel";
// import OrientationPrompt from "../components/OrientationPrompt";
// import ReceivedListModal from "../components/ReceivedListModal";
// import "../components/CreateClass.css";
// import { useLocation } from "react-router";

// function CreateClass(props) {
//   let location = useLocation();

//   let name = location.state.name.name;
//   let schoolid = location.state.schoolid.schoolid;
//   let teacherid = location.state.teacherid.teacherid;
//   let classes = location.state.classes.classes;
//   let rollNumber = location.state.rollNumber;
//   let teacherRoles = location.state.teacherRoles.teacherRoles;
//   let teachers = location.state.teachers.teachers;

//   const [isPortrait, setIsPortrait] = useState(
//     window.matchMedia("(orientation: portrait)").matches
//   );

//   // Updated state management for different modal types
//   const [seniorInfantStatus, setSeniorInfantStatus] = useState('allowed'); // 'allowed', 'awaiting', 'received'
//   const [showRestrictionModal, setShowRestrictionModal] = useState(false);
//   const [showReceivedModal, setShowReceivedModal] = useState(false);
//   const [submissionData, setSubmissionData] = useState(null);

//   // Helper function to calculate academic year
//   const calculateAcademicYear = (date) => {
//     const year = date.getFullYear();
//     const month = date.getMonth() + 1;
//     let startYear, endYear;
    
//     if (month >= 8) {
//       startYear = year;
//       endYear = year + 1;
//     } else {
//       startYear = year - 1;
//       endYear = year;
//     }
    
//     const startYearShort = startYear.toString().slice(-2);
//     const endYearShort = endYear.toString().slice(-2);
//     return `${startYearShort}-${endYearShort}`;
//   };

//   useEffect(() => {
//     window.HubSpotConversations?.widget?.refresh();
//   }, []);

//   useEffect(() => {
//     const handleOrientationChange = () => {
//       setIsPortrait(window.innerWidth < window.innerHeight);
//     };

//     window.addEventListener("resize", handleOrientationChange);

//     return () => {
//       window.removeEventListener("resize", handleOrientationChange);
//     };
//   }, []);

//   useEffect(() => {
//     window.HubSpotConversations?.widget?.refresh();
//   }, []);

//   // Updated conversion methods check
//   useEffect(() => {
//     const checkConversionMethods = async () => {
//       if (schoolid) {
//         try {
//           const filter = { where: { schoolid: schoolid } };
//           const existingMethods = await getClassConversionMethods(filter);
//           const currentAcademicYear = calculateAcademicYear(new Date());
          
//           const conversionMethod = existingMethods.find(
//             method => method.academic_year === currentAcademicYear
//           );

//           if (!conversionMethod) {
//             // No method found - default to awaiting
//             setSeniorInfantStatus('awaiting');
//           } else {
//             const transitionType = conversionMethod.transition_type;
            
//             if (transitionType === 'mix_reassign' || transitionType === 'direct') {
//               setSeniorInfantStatus('allowed');
//             } else if (transitionType === 'mix_reassign_received') {
//               setSeniorInfantStatus('received');
              
//               // Find teacher name from teachers array using teacherid
//               const submittingTeacher = teachers?.find(teacher => teacher.id === conversionMethod.teacherid);
              
//               // Set submission data for the received modal
//               setSubmissionData({
//                 date: conversionMethod.date_submitted,
//                 teacherName: submittingTeacher?.name || 'Unknown Teacher',
//                 academicYear: conversionMethod.academic_year || currentAcademicYear
//               });
//             } else {
//               // Any other transition type - show awaiting modal
//               setSeniorInfantStatus('awaiting');
//             }
//           }
//         } catch (error) {
//           console.error("Error checking conversion methods:", error);
//           setSeniorInfantStatus('awaiting'); // Default to awaiting on error
//         }
//       }
//     };

//     checkConversionMethods();
//   }, [schoolid]);

//   // Modal handlers
//   const handleShowRestrictionModal = () => {
//     if (seniorInfantStatus === 'received') {
//       setShowReceivedModal(true);
//     } else if (seniorInfantStatus === 'awaiting') {
//       setShowRestrictionModal(true);
//     }
//   };

//   const handleCloseRestrictionModal = () => setShowRestrictionModal(false);
//   const handleCloseReceivedModal = () => setShowReceivedModal(false);

//   return (
//     <Container fluid className="vh-100">
//       <HeadingBanner
//         name={"Create a New Class! "}
//         isLoggedIn={true}
//         cloud={true}
//         teacherid={teacherid}
//       />
//       <Row className="h-100">
//         <LeftPanel />
//         <Col sm={{ span: 10, offset: 2 }} className="blue-background">
//           <CreateClassForm
//             teacherid={teacherid}
//             rollNumber={rollNumber}
//             teacherRoles={teacherRoles}
//             seniorInfantRestricted={seniorInfantStatus !== 'allowed'}
//             onShowRestrictionModal={handleShowRestrictionModal}
//           />
//         </Col>
//       </Row>
//       {isPortrait && <OrientationPrompt />}

//       {/* Updated Awaiting Modal */}
//       {/* <Modal 
//         show={showRestrictionModal} 
//         onHide={handleCloseRestrictionModal}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton style={{ borderBottom: '2px solid #e9ecef', paddingBottom: '20px' }}>
//           <Modal.Title style={{ 
//             fontSize: '24px', 
//             fontWeight: '600', 
//             color: '#495057',
//             margin: 0 
//           }}>
//             Senior Infant Class Creation Unavailable
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ padding: '30px', lineHeight: '1.6' }}>
//           <div style={{ 
//             backgroundColor: '#fff3cd', 
//             border: '1px solid #ffeaa7', 
//             borderRadius: '8px', 
//             padding: '20px', 
//             marginBottom: '25px' 
//           }}>
//             <p style={{ 
//               fontSize: '18px', 
//               fontWeight: '600', 
//               color: '#856404', 
//               margin: '0 0 10px 0' 
//             }}>
//               Awaiting updated senior infant class lists for 2025/26.
//             </p>
//             <p style={{ fontSize: '16px', color: '#856404', margin: 0 }}>
//               Please email info@alpaca-assessment.com for queries.
//             </p>
//           </div>
//         </Modal.Body>
//         <Modal.Footer style={{ 
//           borderTop: '1px solid #e9ecef', 
//           padding: '20px 30px',
//           justifyContent: 'center' 
//         }}>
//           <button
//             onClick={handleCloseRestrictionModal}
//             style={{
//               backgroundColor: '#007bff',
//               color: 'white',
//               border: 'none',
//               borderRadius: '6px',
//               padding: '12px 30px',
//               fontSize: '16px',
//               fontWeight: '500',
//               cursor: 'pointer',
//               transition: 'background-color 0.2s ease',
//               minWidth: '120px'
//             }}
//             onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
//             onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
//           >
//             Understood
//           </button>
//         </Modal.Footer>
//       </Modal> */}

//       {/* Received List Modal */}
//       <ReceivedListModal
//         show={showReceivedModal}
//         onClose={handleCloseReceivedModal}
//         submissionData={submissionData}
//       />
//     </Container>
//   );
// }

// export default CreateClass;
